import React from 'react';
import {IconButton} from '../../elements';
import {getRules} from "../../../spirsApi/api-client";
import {useSelector} from "react-redux";
import {StoreType} from "../../../store/spirs/types";
import {useTranslation} from "react-i18next";
import {ReactComponent as CloseIcon} from "./close.svg";
import {useNavigate} from "react-router-dom";

export const MobileRules = () => {
    const navigate = useNavigate();
    const {t} = useTranslation();
    const playerId = useSelector((state: StoreType) => state.spirs.playerInfo.playerId);

    const [rule, setRule] = React.useState<string>('');

    React.useEffect(() => {
        setRule('');
        getRules({player: playerId}).then((response) => response && setRule(response.content));
    }, []);

    const handleClick = () => navigate(-1);

    return (
        <div className="min-w-[261px] text-[14px] mx-auto relative">
            <div className="flex">
                <div className="bg-white text-black text-[16px] rounded-[8px] overflow-y-scroll py-[10px] px-[27px] h-[90vh] mx-[5px] relative w-full">
                    <div className="grid justify-end absolute top-0 right-0 m-[10px]">
                        <IconButton
                            className="text-[#272D33]"
                            onClick={handleClick}
                        >
                            <CloseIcon/>
                        </IconButton>
                    </div>
                    <div className="text-[16px] font-bold mt-[36px]">
                        {t('rulesList.title')}
                    </div>
                    <div dangerouslySetInnerHTML={{__html: rule}} />
                </div>
            </div>
        </div>
    );
}
